import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'; 
import { handleAPIRequest } from '../../../api/api';

const StepRole = ({ updateRole, setPlanId, setPlanAmount }) => {
  const [selectedRole, setSelectedRole] = useState('');
  const [membershipPlans, setMembershipPlans] = useState([]);
  const [filteredPlans, setFilteredPlans] = useState([]);
  const [selectedPlanId, setSelectedPlanId] = useState(null);
  const [visiblePlansIndex, setVisiblePlansIndex] = useState(0);

  useEffect(() => {
    fetchPlans();
  }, []);

  const fetchPlans = async () => {
    try {
      const response = await handleAPIRequest("get", "plan-names", null, null, null);
      if (response) {
        setMembershipPlans(response);
      } else {
        console.error("Failed to fetch membership plans.");
      }
    } catch (error) {
      console.error("Error fetching membership plans:", error);
    }
  };

  const handleRoleSelection = (role) => {
    setSelectedRole(role);
    updateRole(role);

    const rolePlans = membershipPlans.filter(plan => plan.role === role);
    setFilteredPlans(rolePlans);
    setVisiblePlansIndex(0);

    if (rolePlans.length > 0) {
      setSelectedPlanId(rolePlans[0].id);
      setPlanId(rolePlans[0].id);
      setPlanAmount(rolePlans[0].price);
    }
  };

  const handlePlanSelection = (plan) => {
    setSelectedPlanId(plan.id);
    setPlanId(plan.id);
    setPlanAmount(plan.price);
  };

  const handleNext = () => {
    if (visiblePlansIndex + 3 < filteredPlans.length) {
      setVisiblePlansIndex(visiblePlansIndex + 3);
    }
  };

  const handlePrev = () => {
    if (visiblePlansIndex - 3 >= 0) {
      setVisiblePlansIndex(visiblePlansIndex - 3);
    }
  };

  return (
    <div>
      <h3 className="text-xl font-semibold mb-4">Select Your Role</h3>

      {/* Role Dropdown */}
      <div className="mb-4">
        <select
          value={selectedRole}
          onChange={(e) => handleRoleSelection(e.target.value)}
          className="p-2 rounded border border-gray-300 w-full"
        >
          <option value="">Select Role</option>
          <option value="supplier">Supplier</option>
          <option value="donor">Donor</option>
          <option value="ngo">NGO</option>
        </select>
      </div>

      {/* Membership Plans Carousel */}
      {selectedRole && (
        <div className="flex flex-col sm:flex-row justify-between gap-4 mb-4 items-center">
          {filteredPlans.length > 3 && (
            <button onClick={handlePrev} className="p-2 text-lg text-gray-500" disabled={visiblePlansIndex === 0}>
              &lt;
            </button>
          )}

          {filteredPlans.slice(visiblePlansIndex, visiblePlansIndex + 3).map((plan, index) => (
            <div
              key={index}
              onClick={() => handlePlanSelection(plan)}
              className={`p-4 rounded w-full cursor-pointer text-center transition-all duration-300 ${
                selectedPlanId === plan.id ? 'bg-gray-600 text-white' : 'bg-gray-200 hover:bg-gray-300 text-black'
              }`}
            >
              <h4 className="font-bold">{plan.title}</h4>
              <p className="text-sm">{plan.price} for {plan.duration}</p>
            </div>
          ))}

          {filteredPlans.length > 3 && (
            <button onClick={handleNext} className="p-2 text-lg text-gray-500" disabled={visiblePlansIndex + 3 >= filteredPlans.length}>
              &gt;
            </button>
          )}
        </div>
      )}

      {/* Pricing Link */}
      <div className="text-center mb-4">
        <Link to="/pricing" className="text-blue-500 hover:underline">
          View Detailed Price Plan
        </Link>
      </div>
    </div>
  );
};

export default StepRole;
